export default __webpack_public_path__ + "static/media/atkt_resized.2239b30b.png";